import ApiService from './api.service'
class handleError extends Error {
    constructor(errorCode, message) {
        super(message)
        this.name = this.constructor.name
        this.message = message
        this.errorCode = errorCode
    }
}

const apiUrlMaterial = '/material';

const MaterialService = {

    save: async function (data) {
        try {
            const response = await ApiService.post(apiUrlMaterial, data);
            // NOTE: We haven't covered this yet in our ApiService 
            //       but don't worry about this just yet - I'll come back to it later
            ApiService.mount401Interceptor();
            return response.data.success;
        } catch (error) {
            throw new handleError(error.response.status, error.response.data.detail);
        }

    },

    list: async function (page, data) {
        try {
            const response = await ApiService.post(`${apiUrlMaterial}/${page}`, data);
            // NOTE: We haven't covered this yet in our ApiService 
            //       but don't worry about this just yet - I'll come back to it later
            ApiService.mount401Interceptor();
            return response.data.success;
        } catch (error) {
            console.log(error);
            throw new handleError(error.response.status, error.response.data.detail);
        }
    },

    edit: async function (data) {
        try {
            const response = await ApiService.put(apiUrlMaterial, data);
            ApiService.mount401Interceptor();
            return response.data.success;
        } catch (error) {
            throw new handleError(error.response.status, error.response.data.detail);
        }
    }, 
    
    delete: async function(id) {
        try {
            const response = await ApiService.delete(`${apiUrlMaterial}/${id}`);
            ApiService.mount401Interceptor();
            return response.data.success;
        } catch (error) {
            throw new handleError(error.response.status, error.response.data.detail);
        }
    },

    restore: async function (id) {
        try {
            const response = await ApiService.post(`${apiUrlMaterial}/restore/${id}`);
            ApiService.mount401Interceptor();
            return response.data.success;
        } catch (error) {
            throw new handleError(error.response.status, error.response.data.detail);
        }
    }

}

export default MaterialService

export { MaterialService, handleError }